(function() {

	// *************************************************************************
	// Date picker
	// *************************************************************************

	$(document).ready(function() {
		$("input[type='date']").each(function() {
			var $this = $(this);
			var value = $this.val();
			var focus = $this.attr("autofocus");

			// Convert date field to text field
			$this.attr("type", "text");
			$this.attr("autocomplete", "off");

			// Append button (convert to input group)
			$wrapper = $this.wrap("<div class='input-group'></div>").parent();
			$wrapper.append("<div class='input-group-append'><button class='btn btn-primary' type='button'><span class='fas fa-calendar-alt'></span></button></div>");

			var datePicker = $this.datepicker({
				showEvent: "keydown",
				keyboardNav: true,
				autoClose: true,
				todayButton: new Date(),
				// minDate: new Date()
			}).data("datepicker");

			if (value) {
				datePicker.selectDate(new Date(value));
			}

			if (focus) {
				$this.focus();
			}

			// Add button to show calendar
			$wrapper.find("button").click(function() {
				$this.focus();
				datePicker.show();
			});
		});
	});

})();